import { SkeletonBlock } from '~/shared/ui'

export function LoadingSkeleton() {
  return (
    <>
      <SkeletonBlock className="h-[60px]" />
      <div className="px-4 py-2.5">
        <SkeletonBlock className="h-[20px] w-[180px]" />
      </div>
      <div className="px-4 py-2.5">
        <SkeletonBlock className="h-[20px] w-[120px]" />
      </div>
      <SkeletonBlock className="h-[60px]" />
      <div className="px-4 py-2.5">
        <SkeletonBlock className="h-[20px] w-[120px]" />
      </div>
      <div className="px-4 py-2.5">
        <SkeletonBlock className="h-[20px] w-[120px]" />
      </div>
      <div className="px-4 py-2.5">
        <SkeletonBlock className="h-[20px] w-[180px]" />
      </div>
      <div className="px-4 py-2.5">
        <SkeletonBlock className="h-[20px] w-[120px]" />
      </div>
      <div className="px-4 py-2.5">
        <SkeletonBlock className="h-[20px] w-[180px]" />
      </div>
    </>
  )
}
